//NPM Packages
import React, { memo, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { Col, Button } from 'reactstrap';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from 'sweetalert2';

//elements starts with capital letter;
import { InputField, FormBase, Validator } from '../../components';
import { UseModal } from '../../components/Model';

//Helper files
import strings from '../../globalization';
import consts from '../../consts';

//Redux actions
import {
  comboTypes,
  PREFERENCEFORM,
  preferenceForm,
  preferenceFormReset
} from '../../redux/actions';

const Required = () => <span style={{ color: '#dc3545' }}> *</span>;

const PreferenceForm = memo(props => {
  const {
      dispatch,
      initialValues = {},
      formValues = {},
      hide,
      scope,
      id,
      shouldCloseModal,
      updatedColumns
    } = props,
    { params } = props.match || {};

  useEffect(() => {
    dispatch(preferenceForm({ action: 'load', _id: id || params.id }));
  }, []);

  useEffect(() => {
    if (shouldCloseModal) {
      hide(initialValues.IsDefault ? initialValues.PrefName : null);
      dispatch(preferenceFormReset());
    }
  }, [shouldCloseModal]);

  const onSubmit = useCallback(values => {
    let { listId, state, columns, baseFilter } = props;
    delete state.component;
    Object.assign(state, { columns: updatedColumns });
    delete state.state;

    // Prepare preference data
    const prefData = { ...state };

    // Only include searchValue if baseFilter.search exists
    if (baseFilter && baseFilter.search !== undefined) {
      prefData.searchValue = baseFilter.search;
    }

    Object.assign(values, {
      GridId: listId,
      PrefVaue: JSON.stringify(prefData),
      Controller: ''
    });
    dispatch(
      preferenceForm({
        action: values._id ? 'update' : 'add',
        ...values
      })
    );
  }, []);

  const advanceButtons = (
    <Col sm="1" md="1" lg="1" style={{ display: 'flex' }}>
      <Button title={strings.Close} color="danger" onClick={() => hide()}>
        {' '}
        <FontAwesomeIcon icon={faTimes} />{' '}
      </Button>
    </Col>
  );

  const onIsDefaultChange = e => {
    if (e.target.checked === consts.IsDefault) {
      swal.fire(strings.Warning, strings.DefaultPrefWarning, 'warning');
    }
  };

  return (
    <FormBase
      {...props}
      onSubmit={onSubmit}
      isDark={props.isDark}
      title={strings.AddPreference}
      subTitle={(initialValues && initialValues.Name) || strings.New}
      actionInfo={{ action: preferenceForm, actionName: PREFERENCEFORM }}
      disableReset={true}
      historyDisable={true}
      shouldGoBack={false}
      onFormCancel={() => hide()}
      disablePristine={true}
    >
      <>
        <Col sm="12" md="12" lg="12" className="mb-2">
          {strings.Name} <Required />
          <Field
            name="PrefName"
            type="text"
            component={InputField}
            placeholder={strings.Name}
            validate={Validator.required}
          />
        </Col>
        <Col sm="12" md="12" lg="12" className="mb-2">
          {strings.Description} <Required />
          <Field
            name="PrefDesc"
            type="text"
            component={InputField}
            placeholder={strings.Description}
            validate={Validator.required}
          />
        </Col>
        <div className="form-group form-check ml-3">
          <Field
            name="IsDefault"
            type="checkbox"
            component={InputField}
            onChange={onIsDefaultChange}
          />
          <label className="form-check-label">{strings.Default}</label>
        </div>
      </>
    </FormBase>
  );
});

const PreferenceReduxForm = reduxForm({
  form: 'preferenceForm',
  enableReinitialize: true,
  keepValues: true
})(PreferenceForm);

const mapDispatchToProps = dispatch => ({
  change: (field, value) => dispatch(change('preferenceForm', field, value))
});

const mapStateToProps = (state, props) => {
  const { preferenceForm } = state.form;
  const { data, comboType, success, info } = state.preferenceFormData.data;
  const { isDark } = state.settingData;
  return {
    initialValues: data,
    isDark: isDark,
    formValues: preferenceForm ? preferenceForm.values : null,
    shouldCloseModal:
      success &&
      (info === 'RecordSavedSuccessfully' ||
        info === 'RecordUpdatedSuccessfully' ||
        info === 'DeleteSuccess'),
    loginUserData: state.loginData.data,
    currentState: state
  };
};

const PreferenceFormModule = connect(
  mapStateToProps,
  mapDispatchToProps
)(PreferenceReduxForm);

export default props => {
  return <PreferenceFormModule {...props} />;
};
